export default __webpack_public_path__ + "static/media/Type 2.046a31e0.jpg";